(function () {
  /**
   * Modes qui animent les enfants (data-animate-children) en cascade :
   * 'stagger', 'both' et 'stagger-reveal-<dir>'.
   */
  function isStaggerMode(mode) {
    return mode === 'both' || (typeof mode === 'string' && mode.indexOf('stagger') === 0);
  }

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
      rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
      rect.bottom > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.right > 0
    );
  }

  /**
   * Check if an element is inside a closed <details>
   */
  function isInsideClosedDetails(el) {
    var parent = el.parentElement;
    while (parent) {
      if (parent.tagName === 'DETAILS' && !parent.open) return true;
      parent = parent.parentElement;
    }
    return false;
  }

  function initBlockAnimations(scope) {
    var root = scope || document;
    var blocks = root.querySelectorAll('[data-block-animate]');

    blocks.forEach(function (block) {
      if (block._blockAnimInit) return;
      block._blockAnimInit = true;

      var mode = block.getAttribute('data-block-animate');

      // Stagger children setup
      if (isStaggerMode(mode)) {
        var childSelector = block.getAttribute('data-animate-children');
        if (childSelector) {
          var children = block.querySelectorAll(childSelector);
          children.forEach(function (child, i) {
            child.classList.add('animate-child');
            child.style.setProperty('--animation-order', i);
          });
        }
      }

      // Star pop setup (review block)
      var popSelector = block.getAttribute('data-animate-pop');
      if (popSelector) {
        var popElements = block.querySelectorAll(popSelector);
        popElements.forEach(function (el, i) {
          el.classList.add('animate-pop');
          el.style.setProperty('--animation-order', i);
        });
      }

      // If inside a closed <details>, defer to the accordion-open handler
      if (isInsideClosedDetails(block)) {
        block._blockAnimDeferred = true;
        return;
      }

      // If already in viewport, trigger after one paint so initial state is rendered
      if (isInViewport(block)) {
        requestAnimationFrame(function () {
          block.classList.add('is-visible');
        });
        return;
      }

      // IntersectionObserver for below-the-fold elements
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15 }
      );

      observer.observe(block);
    });
  }

  /**
   * Watch all <details> elements for open/close.
   * When a <details> opens, find any deferred animated blocks inside and trigger them.
   * Re-triggers stagger animation each time the accordion reopens.
   */
  function initAccordionAnimationWatcher() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName !== 'open') return;
        var details = mutation.target;
        if (!details.open) return;

        // Find animated blocks inside this details
        var blocks = details.querySelectorAll('[data-block-animate]');
        blocks.forEach(function (block) {
          // Reset and replay stagger animation
          var mode = block.getAttribute('data-block-animate');
          if (isStaggerMode(mode)) {
            var childSelector = block.getAttribute('data-animate-children');
            if (childSelector) {
              var children = block.querySelectorAll(childSelector);
              // Re-setup animate-child in case children were added dynamically
              children.forEach(function (child, i) {
                child.classList.add('animate-child');
                child.style.setProperty('--animation-order', i);
              });
            }

            // Force-reset CSS animations on children so they replay
            block.classList.remove('is-visible');
            var allAnimated = block.querySelectorAll('.animate-child');
            allAnimated.forEach(function (child) {
              child.style.animation = 'none';
              child.offsetHeight; // force reflow
              child.style.animation = '';
            });
            requestAnimationFrame(function () {
              block.classList.add('is-visible');
            });
          }
        });
      });
    });

    // Observe all existing and future <details> elements for open attribute changes
    function observeDetails(root) {
      var detailsEls = (root || document).querySelectorAll('details');
      detailsEls.forEach(function (d) {
        observer.observe(d, { attributes: true, attributeFilter: ['open'] });
      });
    }

    observeDetails();

    // Also observe newly added <details> elements (Shopify section rendering etc.)
    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'DETAILS') {
            observer.observe(node, { attributes: true, attributeFilter: ['open'] });
          }
          if (node.querySelectorAll) {
            var inner = node.querySelectorAll('details');
            inner.forEach(function (d) {
              observer.observe(d, { attributes: true, attributeFilter: ['open'] });
            });
          }
        });
      });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBlockAnimations();
      initAccordionAnimationWatcher();
    });
  } else {
    initBlockAnimations();
    initAccordionAnimationWatcher();
  }

  // Shopify theme editor re-init
  document.addEventListener('shopify:section:load', function (e) {
    initBlockAnimations(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target.querySelector('[data-block-animate]');
    if (block && !block._blockAnimInit) {
      initBlockAnimations(e.target);
    }
    if (block) {
      block.classList.add('is-visible');
    }
  });
})();
